<!--
  Renders the Resource -  White-Paper app route
-->
<template>
  <div>
    <!-- Default - NO resource download selected or postFormat = true -->
    <template
      v-if="
        template === 'default' ||
        (routeData.fields &&
          routeData.fields.postFormat &&
          routeData.fields.postFormat.value === true)
      "
    >
      <div class="row">
        <div
          data-e2e-id="cis-resource-white-paper"
          style="position: relative"
          class="col-lg-12 col-md-12 col-sm-12 template-content"
        >
          <!-- Main Content -->
          <div class="col-lg-9 col-md-9 col-sm-12 template-main-content">
            <!-- Headers -->
            <resource-heading
              v-bind:title="routeData.fields.resourceTitle"
              v-bind:subTitle="routeData.fields.resourceSubtitle"
            />

            <!-- ByLine -->
            <resource-byline v-bind:byLine="routeData.fields.byLine" />

            <!-- Date -->
            <resource-published-date v-bind:publishedAt="routeData.fields.publishedAt" />

            <!-- CTA -->
            <cta v-bind:field="routeData.fields.cta" class="hideDesktop" />

            <!-- Resource Downloads -->
            <resource-downloads v-bind:fields="routeData.fields" class="hideDesktop" />

            <!-- Main Content -->
            <resource-content v-bind:field="routeData.fields.resourceContent" />

            <!-- CTA -->
            <cta v-bind:field="routeData.fields.cta" />

            <p class="cis-resource-disclaimer">
              As of June 23, 2025, the MS-ISAC has introduced a fee-based membership. Any potential
              reference to no-cost MS-ISAC services no longer applies.
            </p>
          </div>
          <!-- Right Rail -->
          <div
            class="col-lg-3 col-md-3 col-sm-12 template-sidebar"
            :class="{ addShadow: isContent }"
          >
            <!-- Placeholder - Right Rail Top -->
            <sc-placeholder name="jss-right-rail-top" :rendering="rendering" />

            <!-- CTA -->
            <cta v-bind:field="routeData.fields.cta" />

            <!-- Related Resources -->
            <related-resource v-bind:fields="routeData.fields" />

            <!-- Resource Downloads -->
            <resource-downloads v-bind:fields="routeData.fields" />

            <!-- Placeholder - Right Rail -->
            <sc-placeholder name="jss-right-rail" :rendering="rendering" />
          </div>
        </div>
      </div>
    </template>
    <!-- Custom - Resource download selected -->
    <template v-else>
      <div class="row">
        <div class="col-lg-12">
          <img
            src="/-/jssmedia/Project/cisecurity/cisecurity/data/media/img/whitepapers-cover"
            class="main-image"
            alt=""
          />
          <div class="main-image-abs col-lg-7 col-lg-offset-1 col-md-8 col-md-offset-1 col-sm-9">
            <!-- Header -->
            <resource-heading v-bind:title="routeData.fields.resourceTitle" />

            <!--Excerpt -->
            <resource-excerpt v-bind:field="routeData.fields" :maxCharacter="120" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 div-paragraphs">
          <div class="col-lg-8 col-md-8 col-sm-7">
            <div class="banking-overview">
              <h3>Overview</h3>
              <!-- Main Content -->
              <resource-content v-bind:field="routeData.fields.resourceContent" />

              <div v-if="routeData.fields && routeData.fields.authorInfo">
                {{ routeData.fields.authorInfo.value }}
              </div>

              <!-- CTA -->
              <cta v-bind:field="routeData.fields.cta" />

              <p class="cis-resource-disclaimer">
                As of June 23, 2025, the MS-ISAC has introduced a fee-based membership. Any
                potential reference to no-cost MS-ISAC services no longer applies.
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-4 col-sm-4 banking-primer template-sidebar"
            :class="{ addShadow: isContent }"
          >
            <!-- Placeholder - Right Rail Top -->
            <sc-placeholder name="jss-right-rail-top" :rendering="rendering" />

            <!-- CTA -->
            <cta v-bind:field="routeData.fields.cta" />

            <!-- Resource Downloads -->
            <resource-downloads v-bind:fields="routeData.fields" />

            <!-- Placeholder - Right Rail -->
            <sc-placeholder name="jss-right-rail" :rendering="rendering" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ResourceContent from './CIS-ResourceContent.vue';
import ResourceByline from './CIS-ResourceByLine.vue';
import ResourcePublishedDate from './CIS-ResourcePublishedDate.vue';
import ResourceHeading from './CIS-ResourceHeading.vue';
import ResourceDownloads from './CIS-ResourceDownloads.vue';
import ResourceExcerpt from './CIS-ResourceExcerpt.vue';
import Cta from './CIS-ResourceCTA.vue';
import RelatedResource from './CIS-ResourceRelatedResources.vue';
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Resource-White-Paper',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  components: {
    ResourceContent,
    ResourceByline,
    ResourcePublishedDate,
    ResourceHeading,
    ResourceDownloads,
    ResourceExcerpt,
    Cta,
    RelatedResource,
    ScPlaceholder: Placeholder
  },
  data: function () {
    return {
      isContent: false
    };
  },
  computed: {
    routeData() {
      // this.$jss is defined on the Vue instance by the SitecoreJssPlugin and provides
      // reactive access to the root level route data provided in layout service data.
      return this.$jss.routeData();
    },
    template() {
      var template = 'default';

      if (
        this.routeData.fields.resourcePdfFile &&
        this.routeData.fields.resourcePdfFile.value &&
        this.routeData.fields.resourcePdfFile.value.href != ''
      ) {
        template = 'custom';
      }

      if (
        this.routeData.fields.resourceWordFile &&
        this.routeData.fields.resourceWordFile.value &&
        this.routeData.fields.resourceWordFile.value.href != ''
      ) {
        template = 'custom';
      }

      if (
        this.routeData.fields.resourceExcelFile &&
        this.routeData.fields.resourceExcelFile.value &&
        this.routeData.fields.resourceExcelFile.value.href != ''
      ) {
        template = 'custom';
      }

      return template;
    }
  },
  mounted() {
    if (window.innerWidth <= 991) {
      if (document.querySelector('.template-sidebar')) {
        var sideBar = document.querySelector('.template-sidebar').innerHTML;
        var newSideBar = sideBar.replace(new RegExp('<!---->', 'g'), '');

        if (newSideBar != '') {
          this.isContent = true;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.template-main-content {
  @include desktop-up {
    padding-left: 0;
  }
}

.main-image {
  @include tablet-down {
    display: none;
  }
}

.main-image-abs {
  @include tablet-down {
    position: relative;
  }

  &:deep() {
    h1 {
      font-size: 4rem;
      line-height: 4.8rem;

      @include phone-only {
        font-size: 3.4rem;
        line-height: 4.4rem;
      }
    }
  }
}

.resource-content {
  &:deep() {
    img {
      max-width: 100%;
      height: auto;
    }
  }
}

.banking-overview {
  padding-top: 0;

  @include desktop-up {
    padding-left: 4rem;
  }

  @include tablet-down {
    padding: 0;
  }

  h4 {
    margin-left: 0;

    &:first-child {
      margin-top: 0;
    }
  }

  p {
    width: 100%;
  }
}

.right-top-cta {
  margin-bottom: 3rem;
}

.hideDesktop {
  margin: 2rem 0 0 0;
  display: block !important;

  @include desktop-up {
    display: none !important;
  }
}

.template-content {
  .cis-resource-disclaimer {
    font-style: italic;
    margin: 20px 0 40px 0 !important;
  }
}
</style>
